var _excluded = ["locale"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Category } from '@prezly/sdk';
import { Locale } from '@prezly/theme-kit-intl';
import { AsyncResolvable } from "../resolvable.mjs";
import { build } from "./build.mjs";
export function generate(_x, _x2) {
  return _generate.apply(this, arguments);
}
function _generate() {
  _generate = _asyncToGenerator(function* (context, options) {
    var [newsroom, locales, categories, stories] = yield AsyncResolvable.resolve(context.newsroom, context.locales, context.categories, context.stories);
    var resolvedContext = {
      newsroom,
      locales,
      categories,
      stories,
      generateUrl: context.generateUrl
    };
    return build([generateHomepageEntries(resolvedContext, options), generateStoriesEntries(resolvedContext, options), generateCategoriesEntries(resolvedContext, options), generateMediaEntries(resolvedContext, options)], {
      baseUrl: options.baseUrl
    });
  });
  return _generate.apply(this, arguments);
}
function generateHomepageEntries(_x3, _x4) {
  return _generateHomepageEntries.apply(this, arguments);
}
function _generateHomepageEntries() {
  _generateHomepageEntries = _asyncToGenerator(function* (context, _ref) {
    var {
      priority = guessPriority,
      changeFrequency = guessChangeFrequency
    } = _ref;
    var {
      locales,
      generateUrl
    } = context;
    var entries = locales.map(localeCode => ({
      locale: localeCode,
      url: generateUrl('index', {
        localeCode
      }),
      priority: priority('index', {
        localeCode
      }),
      changeFrequency: changeFrequency('index', {
        localeCode
      })
    })).filter(isNonEmptyUrl);
    return withAlternateLinks(entries);
  });
  return _generateHomepageEntries.apply(this, arguments);
}
function generateStoriesEntries(_x5, _x6) {
  return _generateStoriesEntries.apply(this, arguments);
}
function _generateStoriesEntries() {
  _generateStoriesEntries = _asyncToGenerator(function* (context, _ref2) {
    var {
      priority = guessPriority,
      changeFrequency = guessChangeFrequency
    } = _ref2;
    var {
      locales,
      stories,
      generateUrl
    } = context;
    var entries = stories.filter(story => locales.includes(story.culture.code)).map(story => {
      var params = _objectSpread(_objectSpread({}, story), {}, {
        localeCode: story.culture.code
      });
      return {
        locale: story.culture.code,
        url: generateUrl('story', params),
        priority: priority('story', params),
        changeFrequency: changeFrequency('story', params)
      };
    }).filter(isNonEmptyUrl);
    return withAlternateLinks(entries);
  });
  return _generateStoriesEntries.apply(this, arguments);
}
function generateCategoriesEntries(_x7, _x8) {
  return _generateCategoriesEntries.apply(this, arguments);
}
function _generateCategoriesEntries() {
  _generateCategoriesEntries = _asyncToGenerator(function* (context, _ref3) {
    var {
      priority = guessPriority,
      changeFrequency = guessChangeFrequency
    } = _ref3;
    var {
      locales,
      categories,
      generateUrl
    } = context;
    var entries = categories.flatMap(category => Category.translations(category).filter(_ref6 => {
      var {
        locale
      } = _ref6;
      return locales.includes(locale);
    }).map(translation => {
      var params = _objectSpread(_objectSpread({}, translation), {}, {
        localeCode: translation.locale
      });
      return {
        locale: translation.locale,
        url: generateUrl('category', params),
        priority: priority('category', params),
        changeFrequency: changeFrequency('category', params)
      };
    })).filter(isNonEmptyUrl);
    return withAlternateLinks(entries);
  });
  return _generateCategoriesEntries.apply(this, arguments);
}
function generateMediaEntries(_x9, _x10) {
  return _generateMediaEntries.apply(this, arguments);
}
function _generateMediaEntries() {
  _generateMediaEntries = _asyncToGenerator(function* (context, _ref4) {
    var {
      priority = guessPriority,
      changeFrequency = guessChangeFrequency
    } = _ref4;
    var {
      newsroom,
      locales,
      generateUrl
    } = context;
    if (newsroom.public_galleries_number === 0) return [];
    var entries = locales.map(localeCode => ({
      locale: localeCode,
      url: generateUrl('media', {
        localeCode
      }),
      priority: priority('media', {
        localeCode
      }),
      changeFrequency: changeFrequency('media', {
        localeCode
      })
    })).filter(isNonEmptyUrl);
    return withAlternateLinks(entries);
  });
  return _generateMediaEntries.apply(this, arguments);
}
export function guessChangeFrequency(routeName) {
  if (routeName === 'index') return 'daily';
  return 'weekly';
}
export function guessPriority(routeName) {
  if (routeName === 'index') return 0.9;
  if (routeName === 'category') return 0.8;
  return 0.7;
}
export function withAlternateLinks(entries) {
  return entries.map(_ref5 => {
    var {
        locale
      } = _ref5,
      entry = _objectWithoutProperties(_ref5, _excluded);
    return _objectSpread(_objectSpread({}, entry), {}, {
      alternate: entries.filter(alt => alt.locale !== locale).map(alt => ({
        url: alt.url,
        lang: Locale.from(alt.locale).isoCode
      }))
    });
  });
}
export function isNonEmptyUrl(value) {
  return typeof value.url === 'string';
}